import React from "react";
import { CTAButton } from "./CTAButton";
type Tone = "cream" | "white" | "navy";
type SectionProps = {
  tone?: Tone;
  cta?: string;
  ctaNote?: string;
  id?: string;
  labelledBy?: string;
  narrow?: boolean;
  children: React.ReactNode;
};
const toneClasses: Record<Tone, string> = {
  cream: "bg-cream text-ink",
  white: "bg-white text-ink",
  navy: "bg-navy text-white"
};
export function Section({
  tone = "cream",
  cta,
  ctaNote,
  id,
  labelledBy,
  narrow,
  children
}: SectionProps) {
  return <section id={id} aria-labelledby={labelledBy} className={`${toneClasses[tone]} px-4 py-14 sm:px-6 md:py-20`} data-id="element-277" data-mp="hf18aazie9kl">
      <div className={`mx-auto ${narrow ? "max-w-3xl" : "max-w-5xl"}`} data-id="element-278" data-mp="2p2awafs3266">
        {children}
        {cta && <div className="mt-10 md:mt-12" data-id="element-279" data-mp="7ndmoqpmvmr1">
            <CTAButton label={cta} note={ctaNote} tone={tone === "navy" ? "dark" : "light"} data-id="element-280" data-mp="veixgrgpvouh" />
          </div>}
      </div>
    </section>;
}
type SectionHeadingProps = {
  id?: string;
  eyebrow?: string;
  title: React.ReactNode;
  sub?: React.ReactNode;
  dark?: boolean;
};
export function SectionHeading({
  id,
  eyebrow,
  title,
  sub,
  dark
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-281" data-mp="2ujnyebet64j0">
      {eyebrow && <p className={`text-xs font-bold uppercase tracking-[0.18em] sm:text-sm ${dark ? "text-gold-light" : "text-gold-dark"}`} data-id="element-282" data-mp="38e6t00oig3qr">
          {eyebrow}
        </p>}
      <h2 id={id} className={`mt-3 font-serif text-[1.95rem] font-bold leading-[1.12] sm:text-4xl md:text-5xl ${dark ? "text-white" : "text-ink"}`} data-id="element-283" data-mp="3ia0fabs17blq">
        {title}
      </h2>
      {sub && <p className={`mt-4 text-base leading-relaxed sm:text-lg ${dark ? "text-white/75" : "text-muted"}`} data-id="element-284" data-mp="3raggfelay6nf">{sub}</p>}
    </div>;
}